import type { ReactNode } from 'react';
import { ThemeProvider } from './theme/ThemeProvider';
import { Toaster } from './Toaster';
import { TooltipProvider } from './Tooltip';

/**
 * Everything the primitives expect above them: theme, shared tooltip
 * timing, and the toast outlet. main.tsx mounts it around the app; tests of
 * components that use `useTheme`, `ThemeToggle`, or toasts can pass it as
 * the render `wrapper`.
 */
export const AppProviders = ({ children }: { children: ReactNode }) => (
  <ThemeProvider>
    <TooltipProvider>
      {children}
      <Toaster />
    </TooltipProvider>
  </ThemeProvider>
);
